import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useStore } from "../../../../../Contexts/GlobalStoreContext";
import InfoModal from './InfoModal';

interface Props {}

/**
 * Utilizes `InfoModal` in order to pass the right properties
 * based on store properties.
 */
const AppInfoModal = observer(
  ({}: Props) => {
    const store = useStore()
    const { t } = useTranslation()
    const {
      titleKey,
      descriptionKey,
      type,
      show,
      showCancelBtn,
      showDuration,
      cancelTextKey,
      proceedTextKey,
      onCancel=() => {},
      onProceed=() => {},
    } = store.infoModalConfig

    const [
      isModalBeingHiddenWithFadeout,
      setIsModalBeingHiddenWithFadeout
    ] = useState(false)

    useEffect(() => {
      if (showDuration == -1) return

      let timeoutId = setTimeout(() => {
        setIsModalBeingHiddenWithFadeout(true)
      }, showDuration)

      return () => {
        clearTimeout(timeoutId)
        setIsModalBeingHiddenWithFadeout(false)
      }
    }, [store.infoModalConfig])

    if (!show) return <></>

    return (
      <InfoModal
        type={type}
        title={t(titleKey)}
        description={descriptionKey ? t(descriptionKey) : undefined}
        cancelText={cancelTextKey ? t(cancelTextKey) : undefined}
        proceedText={proceedTextKey ? t(proceedTextKey) : undefined}
        hideCancelBtn={!showCancelBtn}
        hideModalWithFadeout={isModalBeingHiddenWithFadeout}
        onCancel={() => {
          onCancel()
          store.resetInfoModalConfig()
        }}
        onProceed={() => {
          onProceed()
          store.resetInfoModalConfig()
        }}
        onFadeoutFinish={() => {
          setIsModalBeingHiddenWithFadeout(false)
          store.resetInfoModalConfig()
        }}
      />
    )
  }
)

export default AppInfoModal
